import React from 'react';
import classnames from 'classnames';
import Button from 'components/atoms/Button';

import styles from './index.module.css';

interface ProductFeatureCardProperty {
	imgSrc: string;
	title: React.ReactNode;
	content: string;
	buttonName?: string;
	handleClick?: () => void;
	className?: string;
}

const ProductFeatureCard: React.FC<ProductFeatureCardProperty> = ({
	imgSrc,
	title,
	content,
	buttonName,
	handleClick = () => {},
	className,
}) => (
	<div className={classnames(styles.productFeatureCard, className)}>
		<img src={imgSrc} alt="product pic" />
		<div className={styles.infos}>
			<h2>{title}</h2>
			<p>{content}</p>
			{buttonName && (
				<Button
					name={buttonName}
					size="large"
					pattern="primaryOutline"
					Icon="arrow"
					handleClick={handleClick}
					className={styles.button}
				/>
			)}
		</div>
	</div>
);

export default ProductFeatureCard;
